import * as React from 'react';
import Translate from '../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import { ProductModel } from '../../models/product/productModel';
import Button from "@material-ui/core/Button";
import ProductService from '../../services/productService';
import { ProductImageModel } from '../../models/product/productImageModel';

interface IProps {
    cancelClick: any,
    isVisible: boolean,
    currentProduct: ProductModel,
    imageChoosen: any,
}

interface IState {
    product: ProductModel;
    isLoading: boolean,
    images: Array<ProductImageModel>,
    selectedImage: ProductImageModel | null,
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '90% !important'
            },
            paperFullWidth: {
                width: '65%'
            }
        },
    },
    palette: {
        primary: blue
    }
});

class ProductChooseImageDialog extends React.Component<IProps, IState> {
    snackbar: any;
    productService = new ProductService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            product: props.currentProduct,
            isLoading: false,
            images: new Array<ProductImageModel>(),
            selectedImage: null
        };
    }

    componentDidMount() {
        this.getProductImages();
    }

    componentWillReceiveProps() {
        this.setState({
            selectedImage: this.props.currentProduct.productImage ? this.props.currentProduct.productImage : null
        });
    }

    getProductImages = () => {
        this.setState({
            isLoading: true
        });

        this.productService.getProducImages().then(
            (images: Array<ProductImageModel>) => {
                if (images) {
                    this.setState({
                        images,
                        isLoading: false
                    })
                } else {
                    this.setState({
                        isLoading: false
                    })
                }
            }).catch(error => {
                this.setState({
                    isLoading: false
                });
                this.snackbar.show({ severity: 'error', summary: error.message });
            });
    }

    handleChange = (key, value) => {
        const product: ProductModel = { ...this.state.product };
        product[key] = value;
        this.setState({ product: { ...product } });
    };


    handleChooseBtn = (event) => {
        event.preventDefault();

        let selectedImage = { ...this.state.selectedImage };
        this.props.imageChoosen(selectedImage);
    };

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    handleImageSelected = (image: ProductImageModel) => {
        let selectedImage = this.state.selectedImage

        if (selectedImage && selectedImage.fileId === image.fileId) {
            selectedImage = null;
        } else {
            selectedImage = image;
        }

        this.setState({
            selectedImage
        });
    }


    public render() {
        const { isLoading, images, selectedImage } = this.state;

        let imgStyle = { width: 'auto', maxHeight: 70, cursor: 'pointer' };
        let imgWrap = {
            border: '3px solid', borderColor: '#ddd', display: "flex", flexDirection: "column",
            alignItems: "center", width: "80", height: "83px", padding: "5px", margin: "5px", justifyContent: "center"
        };
        let imgWrapSelected = {
            border: '3px solid', borderColor: '#1976d2', display: "flex",
            alignItems: "center", width: "80", height: "85px", padding: "5px", margin: "5px", justifyContent: "center"
        };

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isVisible}
                    onClose={this.handleCancelButton}
                    fullWidth
                    disableBackdropClick={true}
                >
                    <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('Select graphical element')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        {isLoading ? <Spinner /> : null}
                        <Snackbar ref={(el) => this.snackbar = el} />

                        {images && images.length > 0
                            ? <div style={{ display: "flex", justifyContent: "flex-start", flexWrap: "wrap", overflowY: 'auto', height: "400px" }}>
                                {images.map(image => (
                                    <div key={image.fileId}>
                                        <div style={selectedImage && selectedImage.fileId === image.fileId ? imgWrapSelected : imgWrap}
                                            onClick={() => this.handleImageSelected(image)}>
                                            <img src={`data:${image.contentType};base64,${image.content}`} alt={image.name} style={imgStyle} />
                                        </div>
                                        <div style={{ textAlign: "center" }}>{Translate(image.name)}</div>
                                    </div>
                                ))}
                            </div>
                            : <div>
                                {Translate('No graphical elements added')}
                            </div>}

                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                                {Translate("Cancel")}
                            </Button>
                            <Button onClick={(e) => this.handleChooseBtn(e)} color="primary" variant="contained" disabled={selectedImage === null}>
                                {Translate("Choose")}
                            </Button>
                        </div>
                    </Modal.DialogActions>
                </Dialog >
            </MuiThemeProvider>
        )
    }
}

export default ProductChooseImageDialog;